import { Box, Section } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { ConnectMyCalendar } from 'modules/cronofy/components/ConnectMyCalendar'
import { ConnectedCalendar } from 'modules/cronofy/components/ConnectedCalendar'

import { useAccessCalendarSync } from './useAccessCalendarSync'

const ExternalCalendar = () => {
  const {
    access: { id: accessId },
  } = useCurrentSession()

  const { accessCalendarSync } = useAccessCalendarSync(accessId)
  const isCalendarConnected = !!accessCalendarSync?.sub

  return (
    <Section
      illustration="calendar"
      title={i18n.t('personal_settings.external_calendar.section_title')}
      description={i18n.t('personal_settings.external_calendar.section_description')}
    >
      <Box
        alignItems="flexStart"
        borderRadius={{
          all: 'abs008',
        }}
        border={{
          all: {
            color: 'grey400',
            width: 's1',
            style: 'solid',
          },
        }}
        gap="s12"
        padding="s24"
      >
        {isCalendarConnected ? (
          <ConnectedCalendar calendarSync={accessCalendarSync} />
        ) : (
          <ConnectMyCalendar accessId={accessId} calendarSync={accessCalendarSync} />
        )}
      </Box>
    </Section>
  )
}

export default ExternalCalendar
